export const getMessage = (state) => {
    return state.global.message;
};

export const getHasError = (state) => {
    return state.global.hasError;
};

export const getHasSuccess = (state) => {
    return state.global.hasSuccess;
};

export const getScripts = (state) => {
    return state.global.scripts || [];
};